import { render, staticRenderFns } from "./delete-media-dialog.vue?vue&type=template&id=653262e4"
import script from "./delete-media-dialog.vue?vue&type=script&lang=js"
export * from "./delete-media-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports